import { render, staticRenderFns } from "./demoui.vue?vue&type=template&id=9a37b4f6&scoped=true&"
import script from "./demoui.vue?vue&type=script&lang=js&"
export * from "./demoui.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a37b4f6",
  null
  
)

export default component.exports